// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

import App from "./App";
import router from "./router";
import store from "./store";
import api from "../common/api.js";
Vue.prototype.api = api;

import smCom from "../common/global/smCom.js";
Vue.prototype.fGetSmMenuQx = smCom.fGetSmMenuQx;


import "./assets/css/reset.css";
import "./assets/css/global.css";
import "./assets/fonts/iconfont.css";

// import VxeUIAll from 'vxe-pc-ui'
// import 'vxe-pc-ui/lib/style.css'
// Vue.use(VxeUIAll)
import VxeUIAll from 'vxe-pc-ui'
import 'vxe-pc-ui/lib/style.css'
import VxeUITable from 'vxe-table'
import 'vxe-table/lib/style.css'
// ...

Vue.use(VxeUIAll)
Vue.use(VxeUITable)

// 封装命名组件
import Tree from "./components/Tree.vue";
Vue.component("Tree", Tree);


// 树选择器
import xSelectTree from "./components/x-select-tree.vue";
Vue.component("xSelectTree", xSelectTree);

// 下拉选择器
import xSelectFilter from "./components/x-select-filter.vue";
Vue.component("xSelectFilter", xSelectFilter);
// 时间选择器
import timeChang from "./components/timeChang.vue";
Vue.component("timeChang", timeChang);

// 数字输入框
import xNumberInp from "./components/xNumberInp.vue";
Vue.component("xNumberInp", xNumberInp);

// 图形验证
import SlideVerify from "vue-monoplasty-slide-verify";
Vue.use(SlideVerify);

import xButton from "./components/xButton.vue";
Vue.component("xButton", xButton);

import fLng from "./assets/lng/lng.js";
Vue.prototype.fLng = fLng;
// 请求
import axios from "axios";
Vue.prototype.axios = axios;

import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;
import geoJson from "./assets/js/china.json";
echarts.registerMap("china", geoJson);

//表格导出
Vue.prototype.fExportDataEvent = async (table, qxName) => {
  //由于外部取不到table 所以需要通过函数调用用时传参 来找到该表格
  table.exportData({
    type: "csv"
  });
};
//线上环境去掉console.log
if (process.env.NODE_ENV === "production") {
  if (window) {
    window.console.log = function () { };
  }
}
Vue.config.productionTip = false;

// // 动态修改 favicon
// const updateFavicon = (faviconUrl) => {
//   let link = document.querySelector('link[rel="icon"]');
//   if (!link) {
//     link = document.createElement('link');
//     link.rel = 'icon';
//     link.type = 'image/x-icon';
//     document.head.appendChild(link);
//   }
//   link.href = faviconUrl;
//   console.log('favicon updated to:', faviconUrl);
// };

// // 初始化时设置 favicon
// updateFavicon(store.state.oem.favicon);

// // 监听 store 中 oem.favicon 的变化
// store.subscribe((mutation, state) => {
//   console.log('mutation:', mutation);
//   if (mutation.type === 'setOemState' && mutation.payload.key === 'favicon') {
//     updateFavicon(mutation.payload.value);
//   }
// });

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js